const TABBABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
].join(',');
/**
 * Keeps Tab inside an open options sheet. Headless UI otherwise closes the menu or listbox and moves focus
 * to the page behind the backdrop. Option rows stay on the arrow keys (`tabindex="-1"`).
 *
 * Returns true when the key was Tab and the event has been consumed.
 */
export const trapOptionsSheetTab = (event) => {
    if (event.key !== 'Tab') {
        return false;
    }
    const { currentTarget, shiftKey } = event;
    const tabbables = Array.from(currentTarget.querySelectorAll(TABBABLE_SELECTOR)).filter((element) => element.tabIndex >= 0);
    event.preventDefault();
    event.stopPropagation();
    if (!tabbables.length) {
        return true;
    }
    const currentIndex = tabbables.indexOf(document.activeElement);
    const direction = shiftKey ? -1 : 1;
    let nextIndex = shiftKey ? tabbables.length - 1 : 0;
    if (currentIndex !== -1) {
        nextIndex = (currentIndex + direction + tabbables.length) % tabbables.length;
    }
    const next = tabbables[nextIndex];
    next === null || next === void 0 ? void 0 : next.focus();
    return true;
};
//# sourceMappingURL=trap_options_sheet_tab.js.map